import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { NotificationLiteModel, ReadNotificationInput } from './model';

export function useReadAllNotifications(
  options?: UseMutationOptions<ApiResult<NotificationLiteModel>, ApiError>,
): UseMutationResult<ApiResult<NotificationLiteModel>, ApiError> {
  return useMutation(async function () {
    return await MutationFetchFunction({
      url: 'notifications/read-all',
      method: 'PATCH',
    });
  }, options);
}

export function useReadNotification(
  options?: UseMutationOptions<
    ApiResult<{ message: string }>,
    ApiError,
    ReadNotificationInput
  >,
): UseMutationResult<
  ApiResult<{ message: string }>,
  ApiError,
  ReadNotificationInput
> {
  return useMutation(async function (body) {
    return await MutationFetchFunction({
      url: `notifications/read/${body.id}`,
      method: 'PATCH',
    });
  }, options);
}
